import React from 'react'
import LinearProgress from 'material-ui/LinearProgress'

const Progress = ({ loading }) => {
  return loading ? (
    <LinearProgress
      color="rgb(0, 188, 212)"
    style={{
      backgroundColor: '#ac208e'
    }}
      mode="indeterminate"
    />
  ) : (
    <div
      style={{
        position: 'relative',
        height: '4px',
        width: '100%',
        backgroundColor: '#ccc',
        overflow: 'hidden'
      }}
    />
  )
}

export default Progress



// WEBPACK FOOTER //
// ./src/components/Progress.js